import React, { FC } from 'react';
import injectSheet from 'react-jss';
import CheckBox from 'Components/CheckBox';
import styleSheet from './styles';

interface Props {
  column: any;
  tableCols: any;
  index: number;
  columnConfig: any;
  onCheckBoxClick: (event: any) => void;
  classes?: any;
}

const CheckedCols: FC<Props> = (props: Props) => {
  const { column, tableCols, index, classes, columnConfig, onCheckBoxClick } =
    props;

  return (
    <div className={classes.checkedColumn}>
      <span
        className={classes.checkedReposition}
        style={{ visibility: tableCols.length === 1 ? 'hidden' : 'visible' }}
      />
      <CheckBox
        isFocused={index === 0}
        overrideStyles={{
          display: 'inline-block',
          verticalAlign: 'middle',
          whiteBoxDisplay: 'inline-block',
        }}
        id={column}
        isChecked
        onClick={onCheckBoxClick}
      >
        <span className={classes.checkedColumnName}>
          {columnConfig[column].title}
        </span>
      </CheckBox>
    </div>
  );
};

CheckedCols.defaultProps = {
  classes: {},
};

export default injectSheet(styleSheet)(CheckedCols);
